import { createContext, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { translations } from "./translations";

const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isAr = location.pathname === "/ar" || location.pathname.startsWith("/ar/");
  const lang = isAr ? "ar" : "en";
  const base = isAr ? "/ar" : "/";

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = () => navigate(lang === "ar" ? "/" : "/ar");

  return (
    <Ctx.Provider value={{ t: translations[lang], lang, base, toggleLang }}>
      {children}
    </Ctx.Provider>
  );
}

export const useLanguage = () => useContext(Ctx);
